/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ id: NonNullable<unknown> }} Vehicle_Camera_ChannelInputs */

const vi_vehicle_camera_channel = /** @type {(inputs: Vehicle_Camera_ChannelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Camera ${i?.id}`)
};

/**

* @param {Vehicle_Camera_ChannelInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const vehicle_camera_channel = /** @type {((inputs: Vehicle_Camera_ChannelInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vehicle_Camera_ChannelInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_vehicle_camera_channel(inputs)
});